module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAUCAYAAADoZO9yAAABHElEQVRIS8XWTW7CMBAF4DeKegJ8gy5TkKjUSiRnaCROAUdA0D03oGeo4AplFyK1i4qfS6DAlmUGhUUUIKknieV67cXn8ZuxCf+wGEw7Fc0YPATw0zn4r2TbcY2gk8P85h79pVXIHcJB4O69r7QY1iB/IaxBdAgrEAkig6xV9EzEj53Ym5sMrxSRQTYq/AbwQkTTduyNTWCqIDLITkVBwskChAcTmKqIq4xsW6s+gz+bYuog7sLaFFMXUdg1dTFNEKXtWxWTIrYq/ABoANDJyU1MafBLJ6sUYwKhHWg6jCmEFpJuKMOYRIggRZinuDdpmonb7Ihf33xlAPoFuFs3mEUBFkNuK2MSIb6a/AkuzwGSd4cxSn9W0vbU7TsDNxkDJIUdM8QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn_tick.png
// module id = 4Q3U
// module chunks = 2